<template>
  <!-- Sin ventana abierta no se puede enviar: se esconde el botón de guardar
       en vez de dejar llenar el formulario para fallar recién al confirmar. -->
  <i-modal
    :title="$t('send_quotation')"
    :value="value"
    :load="loading"
    :dont-save="!canSend"
    @submit="submit()"
    @close="close()"
  >
    <v-row>
      <v-col cols="12">
        <v-select
          v-model="selected"
          :items="quotations"
          :loading="loadingList"
          :label="$tc('quote', 1)"
          :item-text="label"
          item-value="pk"
          :no-data-text="$t('no_quotations')"
          outlined
          dense
        />
      </v-col>
      <v-col cols="12">
        <v-textarea
          v-model="body"
          :label="$t('message_to_customer')"
          :hint="$t('quotation_message_hint')"
          persistent-hint
          rows="3"
          outlined
          dense
        />
      </v-col>
      <v-col v-if="!canSend" cols="12">
        <v-alert type="info" dense text class="caption mb-0">
          {{ $t('window_closed') }}
        </v-alert>
      </v-col>
    </v-row>
  </i-modal>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'quotation-dialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    conversation: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      loading: false,
      loadingList: false,
      quotations: [],
      selected: null,
      body: ''
    }
  },
  computed: {
    ...mapGetters({
      company: 'company/getCompanyData'
    }),
    // El envío del PDF va con plantilla o dentro de la ventana; se avisa antes
    // de intentar para no dejar al usuario con un error del proveedor.
    canSend() {
      return this.conversation ? this.conversation.can_send_free_text : false
    }
  },
  methods: {
    close() {
      this.$emit('input', false)
    },
    label(item) {
      const code = item.code || `#${item.pk}`
      return item.date ? `${code} · ${this.dateFormat(item.date)}` : code
    },
    async loadQuotations() {
      if (!this.conversation || !this.conversation.customer) {
        this.quotations = []
        return
      }
      this.loadingList = true
      try {
        const response = await this.$api.quotation.list({
          opt: {
            params: {
              company_id: this.company.pk,
              customer: this.conversation.customer
            }
          }
        })
        const lista =
          response.data.results !== undefined
            ? response.data.results
            : response.data
        // El listado de cotizaciones no respeta el filtro por cliente que se
        // le manda, asi que devuelve tambien las de otros. Se filtra de este
        // lado para no ofrecer la cotizacion de un tercero en el Whatsapp de
        // este cliente. El backend igual la rechaza al enviar.
        this.quotations = lista.filter(
          (item) => item.customer === this.conversation.customer
        )
      } finally {
        this.loadingList = false
      }
    },
    async submit() {
      if (!this.selected) {
        this.$toast.error(this.$t('select_quotation'))
        return
      }
      this.loading = true
      try {
        const response = await this.$api.whatsapp.sendQuotation({
          pk: this.conversation.pk,
          form: { quotation: this.selected, body: this.body },
          opt: {
            params: { company_id: this.company.pk },
            skipErrorToast: true
          }
        })
        this.$toast.success(this.$t('quotation_sent'))
        this.$emit('sent', response.data)
        this.close()
      } catch (e) {
        // Cuando el proveedor rechaza el envio, el mensaje ya quedo creado y
        // marcado como fallido en el hilo. Se cierra igual y se muestra el
        // motivo: dejar el dialogo abierto sin explicacion invita a volver a
        // apretar y mandar la cotizacion dos veces.
        const datos = (e.response && e.response.data) || {}
        this.$toast.error(datos.detail || this.$t('quotation_not_sent'))
        this.$emit('sent', datos.message || null)
        this.close()
      } finally {
        this.loading = false
      }
    }
  },
  watch: {
    value(opened) {
      if (opened) {
        this.selected = null
        this.body = ''
        this.loadQuotations()
      }
    }
  }
}
</script>
